var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientchatfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77764 13.6111C2.54753 13.6539 2.34609 13.4525 2.38893 13.2224L2.53542 12.4356L2.80269 11C2.29218 10.1175 2 9.09284 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C6.90716 14 5.88252 13.7078 5 13.1973L3.56445 13.4646L2.77764 13.6111ZM5.33333 8.86667C5.81198 8.86667 6.2 8.47865 6.2 8C6.2 7.52135 5.81198 7.13333 5.33333 7.13333C4.85469 7.13333 4.46667 7.52135 4.46667 8C4.46667 8.47865 4.85469 8.86667 5.33333 8.86667ZM8 8.86667C8.47865 8.86667 8.86667 8.47865 8.86667 8C8.86667 7.52135 8.47865 7.13333 8 7.13333C7.52135 7.13333 7.13333 7.52135 7.13333 8C7.13333 8.47865 7.52135 8.86667 8 8.86667ZM10.6667 8.86667C11.1453 8.86667 11.5333 8.47865 11.5333 8C11.5333 7.52135 11.1453 7.13333 10.6667 7.13333C10.188 7.13333 9.8 7.52135 9.8 8C9.8 8.47865 10.188 8.86667 10.6667 8.86667Z",
    fill: "url(#paint0_linear_6896_7048)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6896_7048",
    x1: 2,
    y1: 2,
    x2: 14.0978,
    y2: 2.09945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF45A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A6A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientchatfill);
export default __webpack_public_path__ + "static/media/gradient.chat.fill.52c83bea12e05a838b62b7de503f4faa.svg";
export { ForwardRef as ReactComponent };